
<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body">

          <div class="vx-row no-gutter justify-center items-center full-page-bg-color">

            <div class="vx-col hidden lg:block lg:w-1/2">
              <img src="@/assets/images/visa-card.png" alt="login" class="mx-auto" width="100%">
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 bg-color whiteColor px-5 py-5">
              <div class="p-8 login-tabs-container">

                <div class="vx-card__title mb-4">
                  <p style="font-size:20px;font-weight:600" class="mb-4">WalletFlo</p>
                  <div class="py-5">
                    <p style="font-size:18px" class="mb-2">Login</p>
                    <p style="font-size:14px" class="mt-1">Welcome back, please login to your account.</p>
                  </div>
                </div>
                <form
                  id="app"
                  @submit="loginAdmin($event)"
                >
                <div>

                  <div class="inputContainer" id="login">
                    <vs-row>
                      <div class="ml-1 mb-1">
                        Email <span v-if="errors.email.success" class="dangerColor">*</span>
                        <span v-if="!errors.email.success" else>*</span>
                      </div>
                    </vs-row>
                    <vs-input 
                     v-on:keyup.enter="loginAdmin"
                    type="email" 
                      placeholder="Enter your Email" 
                      v-model="email" class="w-full"
                        :danger="errors.email.success" 
                        :danger-text="errors.email.msg"
                        @input="validateEmail($event)"
                        name="email"
                        maxLength="40"/>
                  </div>

                  <div class="mt-5 inputContainer" id="login">
                    <vs-row>
                      <div class="ml-1 mb-1">
                        Password <span v-if="errors.password.success" class="dangerColor">*</span>
                        <span v-if="!errors.password.success" else>*</span>
                      </div>
                    </vs-row>
                    <vs-input v-on:keyup.enter="loginAdmin" type="password"
                     placeholder="Enter your Password" 
                     v-model="password" class="w-full" 
                      :danger="errors.password.success"
                      :danger-text="errors.password.msg"
                       @input="validatePassword($event)"
                       maxLength="30"
                        autocomplete="off"/>
                  </div>

                  <div class="flex flex-wrap justify-between my-5">
                      <vs-checkbox v-model="rememberMe" class="mb-3" style="font-size:14px" >Remember Me</vs-checkbox>
                      <router-link to="/admin/forgot-password" style="color:#4B4BF9">Forgot Password?</router-link>
                  </div>
                  <div class="py-5">

                    <vs-row vs-w="12" vs-type="flex" vs-justify="flex-end">
                        <vs-button color="primary" @click="loginAdmin">
                          Login
                      </vs-button>
                    </vs-row>

                  </div>
                  
                </div>
                </form>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <vs-popup class="holamundo" title="Active Rules" :active.sync="resetPasswordMsg">
      <h3>Password has been successfully reset.</h3>
    </vs-popup>
  </div>
</template>

<script>
import { validateEmail, validatePassword, onLoginSubmit } from '@/views/admin/validation';
import { toast } from '@/keys/toast-messages';
import store from '@/store/store';

export default{
  data() {
    return {
      toast,

      email: "",
      password: "",
      rememberMe: false,

      resetPasswordMsg: false,


      errors: {
          email: {
            msg: '',
            success: false
          },
          password: {
            msg: '',
            success: false
          }
      },
      validateEmail,
      validatePassword,
      onLoginSubmit
    }
  },
  created(){
    if(this.$route.params.token){
        this.resetPasswordMsg = true;
    }
    this.$localStorage.remove('token');
    this.$localStorage.remove('user');
  },
  methods: {
    async loginAdmin(event){
        event.preventDefault();
        
        if(this.onLoginSubmit()) {
            this.$vs.loading({
                background: 'rgba(1,2,3,.2)'
            });
            return new Promise(async (resolve, reject) => {
              await this.$auth.login({ 
                  url: this.$EndPoints.AdminLogin,
                  fetchUser: false,
                  redirect: '/',
                  data: {
                    emailAddress: this.email,
                    password: this.password
                  },
                  rememberMe: this.rememberMe,
                  params: {
                    userType: 'admin'
                  },
                  success (res) {
                  const errors = res.data.response && res.data.response.errors && res.data.response.errors[0]? res.data.response.errors[0] : null;
                  if(errors)
                  {
                    if(errors.incorrectPassword)
                      this.errors.password = {
                        msg: errors.incorrectPassword,
                        success: true
                      }
                    else if (errors.userNotFound)
                      this.errors.email = {
                        msg: errors.userNotFound,
                        success: true
                      }
                    else if (errors.accountSuspended)
                    this.toast(errors.accountSuspended)
                  }
                  else {
                    store.commit('updateUserType', this.$auth.user().user_type)
                    this.$localStorage.set('token', this.$auth.token());
                    this.$localStorage.set('user', JSON.stringify(this.$auth.user()));
                  }
                  this.$vs.loading.close();
                },
                error (err) {
                  this.$vs.loading.close();
                  if (err.response.status !== 401) {
                    this.toast(this.genericErrorMessage());
                  }

                }
              })
          });
        }
    }
  },
}
</script>

<style>
  @import './style.css';
</style>


